import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useInput } from "../utils/useInputHook";
import { useAlert } from "react-alert";
import { Divider, Paper } from '@material-ui/core';
import { forgotPassword } from '../api/auth';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    },
    paper: {
        padding: theme.spacing(2, 4),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '400px',
        minHeight: '500px',
    },
    avatar: {
        margin: theme.spacing(5, 1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function ForgotPasswordPage() {
    const classes = useStyles();
    const alert = useAlert();

    const [loading, setLoading] = useState(false);
    const { value: email, bind: bindEmail } = useInput('');

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (!email) {
            alert.show("Email cannot be empty")
        }
        try {
            setLoading(true);
            const res = await forgotPassword({ email });
            alert.show(res.message);
        } catch (error) {
            alert.show(error.toString())
        } finally {
            setLoading(false);
        }
    }


    return (
        <Container component="main" maxWidth="xs" className={classes.wrapper}>
            <Paper className={classes.paper} elevation={4}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Forgot Password
                </Typography>
                <form className={classes.form} onSubmit={handleForgotPassword} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                disabled={loading}
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                {...bindEmail}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {loading ? <CircularProgress color="inherit" className={classes.circularProgress} size={20} /> : 'Request'}
                    </Button>
                    <Divider style={{ margin: '12px 0' }} />
                    <Grid container justify="center">
                        <Grid item>
                            <Button to="/login" component={Link}>
                                Already have an account? Sign in
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        </Container>
    );
}
